import React from 'react';
import Header from './Header';

const OmnichannelView: React.FC = () => {
  return (
    <div className="flex flex-col bg-[#e9eaee]" style={{ height: '100vh' }}>
      <Header />
      <iframe
        title="Omnichannel Dashboard"
        src="/omnichannel/embed"
        className="w-full flex-1 border-0"
      />
    </div>
  );
};

export default OmnichannelView;
